import Neo from './Neo';
import Phone from './Phone';
import Pin from './Pin';

const Validators = [Neo, Phone, Pin];

export const getValidator = name => {
    if (!name) {
        return null;
    }

    let validator = null;
    name = name.toUpperCase();

    Validators.forEach(v => {
        if (name.indexOf(v.name) > -1) {
            validator = v;
        }
    });

    if (!validator) {
        return validator;
    }

    if (validator.init) {
        validator.init({ name });
    }

    if (!validator.validate) {
        validator.validate = value => {
            let isValidValue = false;
            let isValidLength = false;

            if (
                value.length > 0 &&
                value.match(new RegExp(validator.options.regexp))
            ) {
                isValidValue = true;

                if (value.length === validator.options.numberOfDigits) {
                    isValidLength = true;
                }
            } else if (value.length === 0) {
                isValidValue = true;
            }

            return { isValidValue, isValidLength };
        };
    }

    return validator;
};
